package com.esoris.kmpmoout.modules

import com.esoris.kmpmoout.app.supabase.supabaseModule
import com.esoris.kmpmoout.domaindata.expense.expenseModule
import org.koin.dsl.module

val supabaseMainModule = module {

}
    .plus(supabaseModule)
    .plus(expenseModule)